'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgAlert(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M2.98 14H13.02C14.0467 14 14.6867 12.8867 14.1733 12L9.15333 3.32667C8.64 2.44 7.36 2.44 6.84667 3.32667L1.82667 12C1.31333 12.8867 1.95333 14 2.98 14V14ZM8 9.33333C7.63333 9.33333 7.33333 9.03333 7.33333 8.66667V7.33333C7.33333 6.96667 7.63333 6.66667 8 6.66667C8.36667 6.66667 8.66667 6.96667 8.66667 7.33333V8.66667C8.66667 9.03333 8.36667 9.33333 8 9.33333ZM8.66667 12H7.33333V10.6667H8.66667V12Z", fill: "currentColor" })));
}

module.exports = SvgAlert;
//# sourceMappingURL=Alert.js.map
